import { api } from './api';

export const adminAnalyticsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getAdminAnalytics: builder.query({
      query: ({ toolPeriod = '30d', chartRange = 'week' } = {}) => ({
        url: '/admin/analytics',
        params: { toolPeriod, chartRange },
      }),
      providesTags: (_result, _error, arg) => [
        { type: 'AdminAnalytics', id: `${arg?.toolPeriod ?? '30d'}-${arg?.chartRange ?? 'week'}` },
      ],
    }),
  }),
});

export const { useGetAdminAnalyticsQuery } = adminAnalyticsApi;
